<template>
    <div>
        <nav
            class="navbar custom-header navbar-light bg-faded fixed-top navbar-expand"
        >
            <router-link class="navbar-brand" tag="a" to="/">
                <img src="img/logo.jpg" alt="logo" />
            </router-link>
        </nav>

        <b-navbar class="custom-sub-header" fixed="top" toggleable="lg">
            <div class="menu-name" v-if="!showToggle">
                Loyalty Membership Registration
            </div>
            <div class="custom-nav-bar" v-if="showToggle">
                <b-navbar-nav>
                    <b-nav-item
                        :to="m.path"
                        v-bind:key="m.name"
                        v-for="m in menu"
                        v-bind:class="{
                            active: `/${currentRoute}` == m.path
                        }"
                        >{{ m.name }}</b-nav-item
                    >
                </b-navbar-nav>
                <!-- <b-collapse
                    id="nav-collapse"
                    class="custom-header-menu"
                    v-bind:class="{ highlight: currentRoute != 'home' }"
                    is-nav
                >
                    <b-navbar-nav>
                        <b-nav-item
                            :to="m.path"
                            v-bind:key="m.name"
                            v-for="m in menu"
                            v-bind:class="{
                                active: `/${currentRoute}` == m.path
                            }"
                            >{{ m.name }}</b-nav-item
                        >
                    </b-navbar-nav>
                </b-collapse> -->
            </div>
        </b-navbar>
    </div>
</template>
<script>
/**
 * @event switchLang
 * @event logout
 * @property {object} lbl (require)
 * @property {string} activeTab (optional)
 * @property {object} profile (require)
 * @property {boolean} isLogin (require)
 * @property {ModalController} modalController (optional)
 */
export default {
    name: "top-bar", // <top-bar>
    props: {
        lbl: Object,
        activeTab: String,
        profile: Object,
        isLogin: Boolean,
        modalController: Object,
        isShowToggle: Boolean
    },
    data: function() {
        return {
            confirmModal: null,
            menu: [],
            currentRoute: null,
            showToggle: true
        };
    },
    mounted: function() {
        this.currentRoute = this.$route.name;
        this.showToggle = this.isShowToggle;
        if (this.currentRoute == "home") {
            this.menu = [
                {
                    routerName: "home",
                    name: "Loyalty Membership Registration",
                    path: "/"
                }
            ];
        } else {
            this.menu = [
                {
                    routerName: "registration",
                    name: "New Registration",
                    path: "/registration"
                },
                {
                    routerName: "supplementary",
                    name: "Link Supplementary Card",
                    path: "/supplementary"
                }
            ];
        }
    },
    created: function() {
        // console.log(this.profile);
        if (this.modalController != null) {
            this.confirmModal = this.modalController.confirmModal;
        }
    },
    methods: {
        initial: function() {},

        switchLang: function(locale) {
            this.$emit("switchLang", locale);
        },

        logout: function() {
            this.confirmModal
                .clearText()
                .setTitle("Logout?")
                .setMsg("You need logout?")
                .setBtnOk("Logout")
                .setBtnCancel("No")
                .show();
            this.confirmModal.onClickOk(() => {
                this.$emit("logout");
            });
        },

        goto(page) {
            this.$router.push("/" + page);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "TopBar.scss";
</style>
